import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';
import { AdresseDestinations } from 'constants.js';

import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import ClotureContent from '../../ClotureContent';

import ArticleGestionAutocomplete from 'components/Shared/ArticleGestionAutocomplete';
import MyDatePicker from 'components/Shared/MyDatePicker';

import stringHelper from 'utils/stringHelper';

const styles = theme => ({
    formControl: {
        width: '100%',
        marginTop: '24px'
    },
    detailValue: {
        paddingLeft: theme.spacing(4)
    },
    marginTop: {
        marginTop: 10
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    },
    codePostal: {
        flexBasis: '25%'
    },
    ville: {
        flexBasis: '75%',
        flexGrow: 1
    },
    column: {
        width: '45%'
    },
    cell: {
        padding: '4px 8px 4px 8px'
    }
});

/* Liste des réponses possibles */
const typesDemandeRetour = [
    "Demande de retour à l'émetteur",
    "Demande de retour par Enlèvement"
];

class RenvoiEnPayantDialogContent extends React.Component {

    constructor(props) {
        super(props);

        let articles = [];
        if (props.articles) {
            articles = JSON.parse(JSON.stringify(props.articles));
            articles = articles.map((x) => {
                return { ...x, quantiteAEnlever: 0 };
            });
        }

        this.state = {
            numeroPiece: '',
            retourMarchandiseAttendue: null,
            typeDemandeRetour: null,
            commentaire: "",

            adresseEnlevementNomLivraison: this.props.adresse && this.props.adresse.nomLivraison ? this.props.adresse.nomLivraison : '',
            adresseEnlevementAdresse1: this.props.adresse && this.props.adresse.adresse1 ? this.props.adresse.adresse1 : '',
            adresseEnlevementAdresse2: this.props.adresse && this.props.adresse.adresse2 ? this.props.adresse.adresse2 : '',
            adresseEnlevementCodePostal: this.props.adresse && this.props.adresse.codePostal ? this.props.adresse.codePostal : '',
            adresseEnlevementVille: this.props.adresse && this.props.adresse.ville ? this.props.adresse.ville : '',

            contactClientNom: this.props.contact && this.props.contact.nom ? this.props.contact.nom : '',
            contactClientEmail: this.props.contact && this.props.contact.email ? this.props.contact.email : '',
            contactClientTelephone: this.props.contact && this.props.contact.telephone ? this.props.contact.telephone : '',

            dateSouhaitee: null,

            adresseDestinationCode: '',
            adresseDestinationNom: '',
            adresseDestinationAdresse1: '',
            adresseDestinationAdresse2: '',
            adresseDestinationCodePostal: '',
            adresseDestinationVille: '',

            montantDevis: 0,
            factureClient: '0',
            numeroFacture: '',

            articles: articles,
            poidsTheorique: 0,
            nbPalettes: 0,
            nbColis: 0,
            nbLongueurs: 0,

            articleHorsPiece: null,
            codeTR: '',

            clotureData: null
        };
    }

    componentDidMount() {
        let actionData = this.getActionData(this.state);

        this.props.onChange(actionData);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }

        if (newState.retourMarchandiseAttendue === null) {
            return null;
        }
        else {

            if (newState.retourMarchandiseAttendue === "1") {

                if (newState.typeDemandeRetour === null) {
                    return null;
                }

                if (newState.typeDemandeRetour === "1") {

                    if (!newState.adresseEnlevementNomLivraison
                        || !newState.adresseEnlevementAdresse1
                        || !newState.adresseEnlevementCodePostal
                        || !newState.adresseEnlevementVille
                    ) {
                        return null;
                    }

                    if (newState.adresseDestinationCode === '') {
                        return null;
                    }

                    if (newState.adresseDestinationCode === 3
                        && (!newState.adresseDestinationNom
                            || !newState.adresseDestinationAdresse1
                            || !newState.adresseDestinationCodePostal
                            || !newState.adresseDestinationVille)
                    ) {
                        return null;
                    }
                }
            }
        }

        let actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: "Numéro de pièce",
                position: 0,
                valeurString: newState.numeroPiece
            },
            {
                code: ReclamationActionDetailCodes.RetourMarchandiseAttendue,
                type: ReclamationActionDetailType.Booleen,
                libelle: "Retour de marchandise attendue",
                position: 1,
                valeurBool: newState.retourMarchandiseAttendue === '1'
            },
            {
                code: ReclamationActionDetailCodes.TypeDemandeRetour,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Type de demande",
                position: 2,
                valeurString: typesDemandeRetour[newState.typeDemandeRetour],
                valeurInteger: newState.typeDemandeRetour
            }]
        };

        if (newState.typeDemandeRetour === "1") {
            actionData.details.push({
                code: ReclamationActionDetailCodes.Adresse,
                type: ReclamationActionDetailType.Texte,
                libelle: `Adresse d'enlèvement`,
                position: actionData.details.length,
                valeurString: `${newState.adresseEnlevementNomLivraison}\n${newState.adresseEnlevementAdresse1}\n${newState.adresseEnlevementAdresse2}\n${newState.adresseEnlevementCodePostal} ${newState.adresseEnlevementVille}`
            });

            actionData.details.push({
                code: ReclamationActionDetailCodes.ContactClient,
                type: ReclamationActionDetailType.Texte,
                libelle: `Contact client nécessaire à l'enlèvement`,
                position: actionData.details.length,
                valeurString: `${newState.contactClientNom} (${newState.contactClientEmail} / ${newState.contactClientTelephone})`
            });

            if (newState.dateSouhaitee !== null) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.DateEnlevement,
                    type: ReclamationActionDetailType.Date,
                    libelle: `Date d'enlèvement`,
                    position: actionData.details.length,
                    valeurDate: newState.dateSouhaitee.toDateString()
                });
            }

            let adresseString = `${newState.adresseDestinationNom}\n${newState.adresseDestinationAdresse1}\n${newState.adresseDestinationAdresse2 ? newState.adresseDestinationAdresse2 + "\n" : ""}${newState.adresseDestinationCodePostal} ${newState.adresseDestinationVille}`;
            if (newState.adresseDestinationCode !== 3) {
                if (AdresseDestinations.find(x => x.id === newState.adresseDestinationCode) !== undefined) {
                    adresseString = AdresseDestinations.find(x => x.id === newState.adresseDestinationCode).nom;
                }
            }

            actionData.details.push({
                code: ReclamationActionDetailCodes.AdresseDestination,
                type: ReclamationActionDetailType.Texte,
                libelle: `Adresse de destination`,
                position: actionData.details.length,
                valeurString: adresseString,
                valeurInteger: newState.adresseDestinationCode
            });

            actionData.details.push({
                code: ReclamationActionDetailCodes.MontantDevis,
                type: ReclamationActionDetailType.Flottant,
                libelle: 'Montant du devis',
                position: actionData.details.length,
                valeurFloat: newState.montantDevis
            });


            // Facture client
            if (newState.factureClient === '1') {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.NumeroFacture,
                    type: ReclamationActionDetailType.Texte,
                    libelle: 'Numéro de facture',
                    position: actionData.details.length,
                    valeurString: newState.numeroFacture
                });
            }

            // Articles à enlever
            let articles = newState.articles.filter(x => x.quantiteAEnlever !== 0);
            if (articles.length === 0) {
                return null;
            }
            for (let i = 0; i < articles.length; i++) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.CodeArticleQuantite,
                    type: ReclamationActionDetailType.CodeArticleQuantite,
                    libelle: 'Code article à enlever avec quantité',
                    position: actionData.details.length,
                    valeurInteger: articles[i].quantiteAEnlever,
                    valeurString: articles[i].codeArticle
                });
            }

            // Poids théorique
            actionData.details.push({
                code: ReclamationActionDetailCodes.Poids,
                type: ReclamationActionDetailType.Entier,
                libelle: 'Poids théorique',
                position: actionData.details.length,
                valeurInteger: newState.poidsTheorique
            });

            // Nombre de colis
            actionData.details.push({
                code: ReclamationActionDetailCodes.NombreColis,
                type: ReclamationActionDetailType.Entier,
                libelle: 'Nombre de colis',
                position: actionData.details.length,
                valeurInteger: newState.nbColis
            });

            // Nombre de palettes
            actionData.details.push({
                code: ReclamationActionDetailCodes.NombrePalettes,
                type: ReclamationActionDetailType.Entier,
                libelle: 'Nombre de palettes',
                position: actionData.details.length,
                valeurInteger: newState.nbPalettes
            });

            // Nombre de longueurs
            actionData.details.push({
                code: ReclamationActionDetailCodes.NombreLongueurs,
                type: ReclamationActionDetailType.Entier,
                libelle: 'Nombre de longueurs',
                position: actionData.details.length,
                valeurInteger: newState.nbLongueurs
            });

            // TranporteurInitial
            actionData.details.push({
                code: ReclamationActionDetailCodes.TransporteurInitial,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Transporteur initial',
                position: actionData.details.length,
                valeurString: this.props.transporteurInitial ? this.props.transporteurInitial.nom + ' / ' + this.props.transporteurInitial.contrat : ''
            });
        }

        if (newState.commentaire) {

            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }

        return actionData;
    }

    handleChange = (event, codeArticle) => {

        let newState;
        if (codeArticle) {
            newState = {
                ...this.state,
                articles: this.state.articles.map(article => { let a = article.codeArticle !== codeArticle ? article : { ...article, quantiteAEnlever: Math.max(Number(event.target.value), 0) }; return a; })
            };

            newState.poidsTheorique = newState.articles.reduce((currentValue, nextValue) => currentValue + Number(nextValue.quantiteAEnlever) * nextValue.poids, 0);
        } else {
            newState = {
                ...this.state,
                [event.target.name]: event.target.value
            };
        }

        // Reset des infos de clotures
        if (event.target.name === 'retourMarchandiseAttendue' || event.target.name === 'typeDemandeRetour') {
            newState.clotureData = null;
        }

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData, newState.clotureData);
    }

    handleChangeInteger = (event) => {

        let newState;

        newState = {
            ...this.state,
            [event.target.name]: Math.max(event.target.value, 0)
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData, newState.clotureData);
    }

    handleChangeArticleGestion = (suggestion) => {

        if (!suggestion) {
            return;
        }

        let newState;

        newState = {
            ...this.state,
            articleHorsPiece: { codeArticle: suggestion.reference, designationArticle: suggestion.designation, quantite: 0, poids: suggestion.poids, positionnement: suggestion.positionnement }
        };

        this.setState(newState);
    }

    handleAddArticle = () => {
        let newState;
        let newArticle = JSON.parse(JSON.stringify(this.state.articleHorsPiece));
        newArticle.quantiteAEnlever = 0;

        newState = {
            ...this.state,
            articles: [...this.state.articles, newArticle],
            articleHorsPiece: null
        };

        this.props.clearArticleGestionValue();

        this.setState(newState);
        let actionData = this.getActionData(newState);
        this.props.onChange(actionData, newState.clotureData);
    }

    handleAddTR = () => {
        let newState;
        let newArticle = {
            codeArticle: this.state.codeTR,
            designationArticle: "N/A",
            poids: 0,
            positionnement: "N/A",
            quantite: 0,
            quantiteAEnlever: 0

        };

        newState = {
            ...this.state,
            articles: [...this.state.articles, newArticle],
            codeTR: ''
        };

        this.setState(newState);
        let actionData = this.getActionData(newState);
        this.props.onChange(actionData, newState.clotureData);
    }

    handeChangeCloture = (clotureData) => {
        let newState =
        {
            ...this.state,
            clotureData: clotureData
        };

        this.setState(newState);

        let actionData = this.getActionData(this.state);

        this.props.onChange(actionData, clotureData);
    }

    render() {
        const { classes, reclamationId, transporteurInitial } = this.props;
        const { commentaire, retourMarchandiseAttendue, numeroPiece, typeDemandeRetour } = this.state;

        let addArticleDisabled = !this.state.articleHorsPiece || !this.state.articleHorsPiece.codeArticle || this.state.articleHorsPiece.codeArticle.length === 0;

        if (!addArticleDisabled) {
            addArticleDisabled = this.state.articles.find(x => x.codeArticle === this.state.articleHorsPiece.codeArticle) !== undefined;
        }

        return (
            <DialogContent>
                <TextField className={classes.formControl}
                    required
                    name="numeroPiece"
                    label="Numéro de pièce pour renvoi (prépa ou BL)"
                    placeholder="Numéro de pièce"
                    multiline
                    margin="normal"
                    value={numeroPiece}
                    onChange={e => this.handleChange(e)}
                    autoFocus
                />

                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend">Retour de marchandise attendue ?</FormLabel>
                    <RadioGroup
                        required
                        aria-label="retour"
                        name="retourMarchandiseAttendue"
                        value={retourMarchandiseAttendue}
                        onChange={e => this.handleChange(e)}
                    >
                        <FormControlLabel value="1" control={<Radio />} label="Oui" />
                        <FormControlLabel value="0" control={<Radio />} label="Non" />
                    </RadioGroup>
                </FormControl>

                {retourMarchandiseAttendue && (retourMarchandiseAttendue === "1") && (
                    <React.Fragment>
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">Type de retour : </FormLabel>
                            <RadioGroup
                                aria-label="Type de retour"
                                name="typeDemandeRetour"
                                value={typeDemandeRetour}
                                onChange={e => this.handleChange(e)}
                            >
                                {typesDemandeRetour.map((reponse, index) => (
                                    <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                ))}

                            </RadioGroup>
                        </FormControl>
                    </React.Fragment>
                )}

                {retourMarchandiseAttendue && (retourMarchandiseAttendue === "1") && typeDemandeRetour && (typeDemandeRetour === "1") && (
                    <React.Fragment>
                        <div className={classes.container}>
                            <div className={classes.column}>
                                <div>
                                    <Typography variant="h6" gutterBottom>{`Adresse d'enlèvement :`}</Typography>

                                    <Stack spacing={1}>
                                        <TextField required name="adresseEnlevementNomLivraison" label="Nom" value={this.state.adresseEnlevementNomLivraison} onChange={e => this.handleChange(e)} fullWidth />
                                        <TextField required name="adresseEnlevementAdresse1" label="Adresse" value={this.state.adresseEnlevementAdresse1} onChange={e => this.handleChange(e)} fullWidth />
                                        <TextField name="adresseEnlevementAdresse2" label="Complément" value={!this.state.adresseEnlevementAdresse2 ? '' : this.state.adresseEnlevementAdresse2} onChange={e => this.handleChange(e)} fullWidth />
                                        <TextField required name="adresseEnlevementCodePostal" label="Code Postal" value={this.state.adresseEnlevementCodePostal} onChange={e => this.handleChange(e)} />
                                        <TextField required name="adresseEnlevementVille" label="Ville" value={this.state.adresseEnlevementVille} onChange={e => this.handleChange(e)} />
                                    </Stack>

                                </div>

                                <div>
                                    <Typography variant="h6" gutterBottom className={classes.marginTop}>Contact client nécessaire à l'enlèvement :</Typography>
                                    <Stack spacing={1}>
                                        <TextField required name="contactClientNom" label="Nom" value={this.state.contactClientNom} onChange={e => this.handleChange(e)} fullWidth />
                                        <TextField required name="contactClientEmail" label="Email" value={this.state.contactClientEmail} onChange={e => this.handleChange(e)} fullWidth />
                                        <TextField required name="contactClientTelephone" label="Téléphone" value={this.state.contactClientTelephone} onChange={e => this.handleChange(e)} fullWidth />
                                    </Stack>

                                </div>
                            </div>

                            <div className={classes.column}>
                                <div>
                                    <Typography variant="h6" gutterBottom>Adresse de destination :</Typography>


                                    <TextField
                                        id="adresseDestinationCode"
                                        name="adresseDestinationCode"
                                        label={"Destination"}
                                        fullWidth
                                        required
                                        select

                                        SelectProps={{
                                            value: this.state.adresseDestinationCode,
                                            onChange: (e) => this.handleChange(e)
                                        }}
                                    >

                                        {AdresseDestinations.map(adresse => (

                                            <MenuItem key={adresse.id} value={adresse.id}>{adresse.nom}</MenuItem>

                                        ))}
                                    </TextField>

                                    {this.state.adresseDestinationCode === 3 && (
                                        <Stack spacing={1} mt={1}>
                                            <TextField required name="adresseDestinationNom" label="Nom" value={this.state.adresseDestinationNom} onChange={e => this.handleChange(e)} fullWidth autoFocus />
                                            <TextField required name="adresseDestinationAdresse1" label="Adresse" value={this.state.adresseDestinationAdresse1} onChange={e => this.handleChange(e)} fullWidth />
                                            <TextField name="adresseDestinationAdresse2" label="Complément" value={this.state.adresseDestinationAdresse2} onChange={e => this.handleChange(e)} fullWidth />
                                            <TextField required name="adresseDestinationCodePostal" label="Code Postal" value={this.state.adresseDestinationCodePostal} onChange={e => this.handleChange(e)} />
                                            <TextField required name="adresseDestinationVille" label="Ville" value={this.state.adresseDestinationVille} onChange={e => this.handleChange(e)} />
                                        </Stack>
                                    )}
                                </div>

                                <div>
                                    <Typography variant="h6" gutterBottom className={classes.marginTop}>Facture client :</Typography>

                                    <TextField required name="montantDevis" label="Montant du devis transporteur" value={this.state.montantDevis} fullWidth onChange={e => this.handleChange(e)} />

                                    <FormControl component="fieldset" className={classes.marginTop}>
                                        <FormLabel component="legend">Facturé au client ?</FormLabel>
                                        <RadioGroup required name="factureClient" className={classes.group} value={this.state.factureClient} onChange={e => this.handleChange(e)} row>
                                            <FormControlLabel value="1" control={<Radio />} label="Oui" />
                                            <FormControlLabel value="0" control={<Radio />} label="Non" />
                                        </RadioGroup>
                                    </FormControl>

                                    {this.state.factureClient === '1' && (
                                        <TextField required name="numeroFacture" label="Numéro de facture" fullWidth value={this.state.numeroFacture} onChange={e => this.handleChange(e)} />
                                    )}
                                </div>


                                {transporteurInitial && (
                                    <div>

                                        <Typography variant="h6" gutterBottom className={classes.marginTop}>Transporteur initial :</Typography>

                                        <Typography gutterBottom>{transporteurInitial.nom} / {transporteurInitial.contrat}</Typography>

                                    </div>
                                )}

                            </div>
                        </div>

                        <div>
                            <Typography variant="h6" className={classes.marginTop} gutterBottom>Article(s) à enlever :</Typography>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.cell}>Code article</TableCell>
                                        <TableCell className={classes.cell}>Désignation</TableCell>
                                        <TableCell className={classes.cell}>Quantité<br />commandé</TableCell>
                                        <TableCell className={classes.cell}>Quantité à enlever</TableCell>
                                        <TableCell className={classes.cell}>Poids unitaire</TableCell>
                                        <TableCell className={classes.cell}>Positionnement</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.articles.map(x => (
                                        <TableRow key={x.codeArticle}>
                                            <TableCell className={classes.cell}>{x.codeArticle}</TableCell>
                                            <TableCell className={classes.cell}>{x.designationArticle}</TableCell>
                                            <TableCell className={classes.cell}>{x.quantite}</TableCell>
                                            <TableCell className={classes.cell}><TextField size="small" type="number" value={x.quantiteAEnlever} onChange={e => this.handleChange(e, x.codeArticle)} /></TableCell>
                                            <TableCell className={classes.cell}>{x.poids} g</TableCell>
                                            <TableCell className={classes.cell}>{x.positionnement}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            <Stack direction="row" mt={1} spacing={1} justifyContent="space-between">
                                <Stack spacing={1} sx={{ flexGrow: 1 }} alignItems="flex-start">

                                    <ArticleGestionAutocomplete variant="outlined" size="medium" onChange={this.handleChangeArticleGestion} label="Article hors pièce" infosLogistique />

                                    <Button onClick={this.handleAddArticle} disabled={addArticleDisabled}>Ajouter</Button>

                                </Stack>
                                <Stack spacing={1} sx={{ flexGrow: 1 }} alignItems="flex-start">
                                    <TextField name="codeTR" label="Code TR" value={this.state.codeTR} onChange={e => this.handleChange(e)} fullWidth />

                                    <Button onClick={this.handleAddTR} disabled={this.state.codeTR === ''}>Ajouter TR</Button>

                                </Stack>

                            </Stack>


                            <div>
                                <Typography variant="h6" gutterBottom>Expédition :</Typography>

                                <MyDatePicker
                                    label="Date d'enlèvement souhaitée"
                                    value={this.state.dateSouhaitee}
                                    onChange={value => this.handleChange({ target: { name: 'dateSouhaitee', value: value } })}
                                    disableFuture={false}
                                    disablePast={true}
                                    disableSunday={true}
                                    fullWidth
                                />

                                <TextField required name="poidsTheorique" label="Poids théorique (en g)" value={this.state.poidsTheorique} onChange={this.handleChangeInteger} className={classes.marginTop} fullWidth />
                                <div className={classes.container}>
                                    <TextField className={classes.marginTop} name="nbPalettes" label="Nombre de palettes" type="number" value={this.state.nbPalettes} onChange={this.handleChangeInteger} />
                                    <TextField className={classes.marginTop} name="nbColis" label="Nombre de colis" type="number" value={this.state.nbColis} onChange={this.handleChangeInteger} />
                                    <TextField className={classes.marginTop} name="nbLongueurs" label="Nombre de longueurs" type="number" value={this.state.nbLongueurs} onChange={this.handleChangeInteger} />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}

                <TextField className={classes.formControl}
                    name="commentaire"
                    label="Commentaire"
                    placeholder="Commentaire"
                    multiline
                    margin="normal"
                    value={commentaire}
                    onChange={e => this.handleChange(e)}
                />




                {retourMarchandiseAttendue === "1" && typeDemandeRetour === "1" && (
                    <React.Fragment>
                        <p>Le dossier après-vente sera clôturé, veuillez spécifiez le motif de résolution et la cause principale</p>
                        <ClotureContent onChange={this.handeChangeCloture} reclamationId={reclamationId} withDropzone autoFocus={false} />
                    </React.Fragment>
                )}


            </DialogContent>
        );
    }
}

RenvoiEnPayantDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    articles: PropTypes.array.isRequired,
    adresse: PropTypes.object
};

export default withStyles(styles)(RenvoiEnPayantDialogContent);
